import React, { Component } from "react";
import { Redirect, Link, NavLink } from "react-router-dom";
import $ from "jquery";
import Cookies from "universal-cookie";
import API from "../../../utils/API";
import { Api } from "../../../utils/Variables";
import { getCookieField, capitalizeFirst, makeUrl } from "../../../utils";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryList: [],
    };
  }

  handleWindowScroll() {
    //var header = document.getElementById("top-header");
    var header = document.getElementsByClassName("app-page-content")[0];
    // Get the offset position of the navbar
    var sticky = header.offsetTop;

    if (window.pageYOffset > sticky) {
      header.classList.add("fixed-top");
    } else {
      header.classList.remove("fixed-top");
    }
  }

  render() {
    $("html, body").animate({ scrollTop: 0 }, "slow");

    return (
      <nav className="navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0">
        <a className="navbar-brand col-sm-3 col-md-3 mr-0" href="javascript:;">
          CRITERION-WISE REPORT
        </a>

        <img
          src={Api.LOGO}
          style={{ height: "60px", border: "1px solid #000" }}
          className=""
        />

        <ul className="navbar-nav px-3">
          <li className="nav-item text-nowrap">
            <a className="nav-link" href="javascript:;"></a>
          </li>
        </ul>

        {this.props.type && (
          <div className="top_type_container">
            {this.props.type == "qnm" && (
              <span>Quantitative Metrics (QnM)</span>
            )}
            {this.props.type == "qlm" && <span>Qualitative Metrics (QlM)</span>}
          </div>
        )}
      </nav>
    );
  }
}
export default Header;
